import React from 'react';
import { DialogContentText } from '@mui/material';
import { useGlobalization } from '@Translations/useGlobalization';
import { DeleteConfirmationDialog } from '../DeleteConfirmationDialog';

interface DeleteDeteriorationModelDialogProps {
	open: boolean;
	modelName: string;
	onClose: () => void;
	onConfirm: () => void;
	isDeleting?: boolean;
}

export const DeleteDeteriorationModelDialog: React.FC<DeleteDeteriorationModelDialogProps> = ({
	open,
	modelName,
	onClose,
	onConfirm,
	isDeleting = false,
}) => {
	const { t } = useGlobalization();

	return (
		<DeleteConfirmationDialog
			open={open}
			title={t('Delete Deterioration Model')}
			onClose={onClose}
			onConfirm={onConfirm}
			isDeleting={isDeleting}>
			<DialogContentText>
				{t('Are you sure you want to delete the deterioration model "{{name}}"? This action cannot be undone.', {
					name: modelName,
				})}
			</DialogContentText>
		</DeleteConfirmationDialog>
	);
};
